import GenericIdValue from "./GenericIdValue";
import MsLanguageValueObj from "./MsLanguageValueObj";
import GenericIdValueList from "./GenericIdValueList";
import {keys} from "../config/nameSpacesKeys";
import {assetKeys} from "../config/constants";

export default class ProcessingResource {
  constructor(name, initialValue, namespace, mediaTypeNameSpace,
      formatNameSpace, processingResourceTypeNameSpace, languageNameSpace, languageCodeNameSpace, languageVarietyNameNameSpace,
      regionNameSpace, scriptNameSpace, variantNameSpace, isEditor = false) {
    this.isEditor = isEditor;
    this.namespace = namespace;
    this.name = name;
    this.mediaTypeNameSpace = mediaTypeNameSpace;
    this.formatNameSpace = formatNameSpace;
    this.languageNameSpace = languageNameSpace;
    this.processingResourceTypeNameSpace = processingResourceTypeNameSpace;

    this.languageCodeNameSpace = languageCodeNameSpace;
    this.languageVarietyNameNameSpace = languageVarietyNameNameSpace;
    this.regionNameSpace = regionNameSpace;
    this.scriptNameSpace = scriptNameSpace;
    this.variantNameSpace = variantNameSpace;

    this.format = new GenericIdValueList("format", null, formatNameSpace);
    this.mediaType = new GenericIdValueList("mediaType", null, mediaTypeNameSpace);
    this.processingResourceType = new GenericIdValue("processingResourceType", null, processingResourceTypeNameSpace);
    this.languageList = [];
    // new MsLanguageValueObjList("language", null, languageNameSpace, languageCodeNameSpace, languageVarietyNameNameSpace,
    //     regionNameSpace, scriptNameSpace, variantNameSpace, isEditor);

    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.createEmptyLanguageObj();
    }
  }

  createEmptyLanguageObj() {
    const langObj = new MsLanguageValueObj("language", null, keys.mslanguage, this.languageCodeNameSpace, this.languageVarietyNameNameSpace,
        this.regionNameSpace, this.scriptNameSpace, this.variantNameSpace, this.isEditor);
    this.languageList.push(langObj);
  }

  addValueObj(obj) {
    // console.log(obj);
    const langObj = new MsLanguageValueObj("language", obj, keys.mslanguage, this.languageCodeNameSpace, this.languageVarietyNameNameSpace,
        this.regionNameSpace, this.scriptNameSpace, this.variantNameSpace, this.isEditor);
    // console.log(langObj);
    this.languageList.push(langObj);
  }

  removeValueObj(obj, index) {
    if (index < 0 || index >= this.languageList.length) {
      return false;
    }
    this.languageList.splice(index, 1);
  }

  setLanguagesList(flanguagesList) {
    this.languagesList = flanguagesList;
  }

  setLanguage(inputObj) {
    const langObj = inputObj[keys.mslanguage]; // we use a LOWER case l here
    // console.log(langObj);
    if (Array.isArray(langObj)) {
      for (const entry of Object.entries(langObj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      if (!langObj && this.isEditor) { // if it is coming from the editor, and the identifier was not fiiled out, then it is empy
        this.addValueObj(langObj); // we have to add an object to render the form correctly
      }
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getMediaTypeObj() {
    return this.mediaType;
  }
  setMediaTypeObj(mediaTypeObj) {
    this.mediaType = mediaTypeObj;
  }

  getFormatObj() {
    return this.format;
  }

  setFormatObj(formatObj) {
    this.format = formatObj;
  }

  getFormatObj() {
    return this.format;
  }

  setFormatObj(formatObj) {
    this.format = formatObj;
  }

  setProcessingResourceTypeNameSpace(obj) {
    this.processingResourceType = obj;
  }

  getProcessingResourceTypeNameSpace() {
    return this.processingResourceType;
  }

  setLanguagesList(langList) {
    this.languageList.setLanguagesList(langList);
  }

  getLanguagesList() {
    return this.languageList;
  }

  setValueObj(obj) {
    // console.log(obj);
    this.mediaType.parseInputJSON(obj);
    this.processingResourceType.parseInputJSON(obj);
    this.format.parseInputJSON(obj);
    this.setLanguage(obj);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    // console.log(inputJSON, this.namespace);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const obj = {};
    const mediaTypeExpanded = this.mediaType.getExpandedFormatValue();
    const formatExpanded = this.format.getExpandedFormatValue();
    const processingResourceTypeExpanded = this.processingResourceType.getExpandedFormatValue();
    const languageExpanded = [];
    for (let index = 0; index < this.languageList.length; index++) {
      const languageItem = this.languageList[index];
      languageExpanded.push(languageItem.getExpandedFormatValue());
    }
    obj[assetKeys.type] = [`${keys.processingResource}`];
    obj[this.mediaType.getNameSpace()] = mediaTypeExpanded;
    obj[keys.mslanguage] = languageExpanded;
    obj[this.format.getNameSpace()] = formatExpanded;
    obj[this.processingResourceType.getNameSpace()] = processingResourceTypeExpanded;
    return obj;
  }

  isEmpty() {
    const condition1 = this.format.isEmpty() && this.mediaType.isEmpty() && this.processingResourceType.isEmpty();
    let condition2 = true;
    for (let index = 0; index < this.languageList.length; index++) {
      const languageItem = this.languageList[index];
      condition2 = condition2 && languageItem.isEmpty();
    }
    return condition1 && condition2;
  }
}
